/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {Breadcrumb} from "antd";
import {Link} from "react-router-dom";
import {ApiTable} from "../components/table";
import {useAppDispatch, useAppSelector} from "../store";
import {openDrawer} from "../reducers/drawers-reducer";
import {Device} from "../core/datamodel";
import {CustomButton} from "../components/buttons";
import {IconSet} from "../components/icons";

export default function DeviceListView(props: any) {
    const dispatch = useAppDispatch();

    return (
        <>
            <Breadcrumb style={{paddingTop: 6, paddingBottom: 6}}>
                <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item>Geräte</Breadcrumb.Item>
            </Breadcrumb>

            <ApiTable
                title={<><IconSet type='devices'/> Geräte</>}
                id="Geräte"
                url="devices"
                reloadSignals={[
                    useAppSelector(state => state.reloadSignals.device),
                    useAppSelector(state => state.reloadSignals.upload),
                ]}
                searchable
                clickable
                buttons={
                    <CustomButton
                        mode={'add'}
                        tooltip={"Neues Gerät hinzufügen"}
                        onClick={() => dispatch(openDrawer({key: 'device', object: new Device({})}))}
                    />
                }
            />
        </>
    )
}